import { render, staticRenderFns } from "./new-orders.vue?vue&type=template&id=4cabc64d&"
import script from "./new-orders.vue?vue&type=script&lang=js&"
export * from "./new-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports